import { useState, useEffect, useRef } from 'react';
import { isIntersectionObserverSupported } from '@helpers/browser';

export const useIntersectionObserver = ({
    active = true,
    elementRef = null,
    threshold = 0.1,
    root = null,
    rootMargin = '0%'
}) => {
    const [IOEntry, setIOEntry] = useState({});
    const observerRef = useRef(null);

    const updateEntry = ([entry]) => {
        setIOEntry(entry);
    };

    const getObserver = () => {
        let observer = observerRef.current;

        if (observer === null) {
            const settings = { threshold, root, rootMargin };
            observer = new IntersectionObserver(updateEntry, settings);
            observerRef.current = observer;
        }

        return observer;
    };

    useEffect(() => {
        const node = elementRef && elementRef.current;

        if (!active || !isIntersectionObserverSupported() || !node) {
            return;
        }

        const observer = getObserver();
        observer.observe(node);

        // eslint-disable-next-line consistent-return
        return () => {
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elementRef, threshold, root, rootMargin]);

    return [!!IOEntry.isIntersecting, observerRef.current, IOEntry];
};
